import React from "react";

const LOGO = "https://customer-assets.emergentagent.com/job_ice-craft-1/artifacts/gok5iiay_960e76ad-0bef-44cf-a65a-9b4d4d6aa7d2.jpeg";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative bg-obsidian-900 border-t border-white/10 pt-24 pb-10 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
                {/* Massive brand name */}
                <div className="relative mb-16">
                    <h2 className="font-serif-display italic text-[18vw] md:text-[16vw] leading-[0.85] tracking-tighter text-ice-50/10 select-none">
                        Chill Blox
                    </h2>
                    <div className="absolute inset-0 flex items-end pb-6 md:pb-10">
                        <p className="font-script text-amber-glow text-3xl md:text-4xl">
                            made slowly, served colder.
                        </p>
                    </div>
                </div>

                {/* Logo + domain row */}
                <div className="flex flex-wrap items-center justify-between gap-6 mb-12 border-b border-white/10 pb-10">
                    <div className="flex items-center gap-4">
                        <img
                            src={LOGO}
                            alt="Chill Blox mascot"
                            className="w-14 h-14 object-cover rounded-full ring-1 ring-white/10"
                        />
                        <div>
                            <div className="font-serif-display text-2xl">
                                Chill <span className="italic text-[#E63946]">Blox</span>
                                <span className="align-super text-[0.55rem] text-ice-400 ml-0.5">™</span>
                            </div>
                            <a
                                href="https://icefarmers.com"
                                className="text-[0.72rem] uppercase tracking-[0.3em] text-amber-glow hover:text-ice-50 transition-colors"
                            >
                                icefarmers.com
                            </a>
                        </div>
                    </div>
                    <p className="font-script text-amber-glow text-2xl md:text-3xl">
                        perfectly clear, since day one.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <FooterCol title="Atelier">
                        <a href="#craft" className="footer-link">The Craft</a>
                        <a href="#pairings" className="footer-link">Pairings</a>
                        <a href="#concierge" className="footer-link">Concierge</a>
                    </FooterCol>
                    <FooterCol title="Contact">
                        <a href="#concierge" className="footer-link">Concierge</a>
                        <a href="mailto:support@icefarmers.com" className="footer-link">
                            support@icefarmers.com
                        </a>
                    </FooterCol>
                    <FooterCol title="Lore">
                        <p className="text-ice-400 text-sm leading-relaxed">
                            We do not make a lot of ice. Each block takes three days. Each cube, an hour of attention.
                            The rest is restraint.
                        </p>
                    </FooterCol>
                </div>

                <div className="hairline mt-16 mb-8" />

                <div className="flex flex-wrap items-center justify-between gap-4 text-[0.68rem] uppercase tracking-[0.28em] text-ice-400">
                    <span data-testid="footer-copyright">© MMXXVI Chill Blox™ · icefarmers.com</span>
                    <span className="font-script text-lg text-amber-glow normal-case tracking-normal">
                        crystalline by design
                    </span>
                    <span>Crafted in New York</span>
                </div>
            </div>
            <style>{`
                .footer-link {
                    display: block;
                    color: #8A8A93;
                    text-decoration: none;
                    font-size: 0.9rem;
                    margin-bottom: 10px;
                    transition: color 0.3s ease;
                }
                .footer-link:hover {
                    color: #D6B571;
                }
            `}</style>
        </footer>
    );
}

function FooterCol({ title, children }) {
    return (
        <div>
            <h4 className="text-[0.65rem] uppercase tracking-[0.3em] text-amber-glow mb-5">{title}</h4>
            <div className="space-y-2">{children}</div>
        </div>
    );
}
